import React, { useState, useEffect, useRef } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

// Components 

import Box from '@mui/material/Box';
import InfoRow from '../../../general/inputs/InfoRow';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import SignalWifiStatusbar4BarIcon from '@mui/icons-material/SignalWifiStatusbar4Bar';
import EmailIcon from '@mui/icons-material/Email';
import getStatusColor from '../../../../util/style/getStatusColor';
import UpdateIcon from '@mui/icons-material/Update';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import FingerprintIcon from '@mui/icons-material/Fingerprint';
import ApartmentIcon from '@mui/icons-material/Apartment';
import SettingsIcon from '@mui/icons-material/Settings';
import TollIcon from '@mui/icons-material/Toll';
import moment from 'moment';
import { groupAccessStatusList } from './DoctorSettingsOptions';
import { getDoctor, updateDoctorStatus, updateGroupAccessStatus } from '../../../../routes/hacker/users';
import { setNotificationMessage } from '../../../../redux/features/general/notification';
import { setSelectedDoctor, setIsRefreshDoctorsList } from '../../../../redux/features/hacker/users/doctorsAccess';
import { setSelectedGroupAccess } from '../../../../redux/features/hacker/users/groupsAccess';
import getCapitalizedString from '../../../../util/style/getCapitalizedString';
interface Props { 

}; 

const DoctorSettings: React.FC<Props> = ({ }) => {

    const dispatch = useAppDispatch(); 
    const { t } = useTranslation(); 
    const navigate = useNavigate(); 

    const colors = useAppSelector(state => state.theme.colors); 

    const selectedDoctor = useAppSelector(state => state.doctorsAccess.selectedDoctor); 
    const selectedGroup = useAppSelector(state => state.groupsAccess.selectedGroup); 
    const selectedGroupAccess = useAppSelector(state => state.groupsAccess.selectedGroupAccess); 

    // -- 

    const handleDoctor = async () => { 

        const res = await getDoctor(selectedDoctor._id); 

        if (res?.data.status === 200) { 

            dispatch(setSelectedDoctor(res.data.doctor)); 
            
        }; 

    }; 

    // -- 

    const handleGroupStatus = async (item: any) => { 

      if (item) { 

        const res = await updateGroupAccessStatus(selectedGroupAccess?._id, item.status) as any; 

        if (res.data.status === 200) { 
  
          handleDoctor();
  
          dispatch(setSelectedGroupAccess(res.data.groupAccess)); 

          dispatch(setNotificationMessage('Group Access Status Successfully Updated.')); 
  
        }; 

      }; 

    }; 

    // -- 

    const handleDoctorStatus = async (item: any) => { 

      if (item) { 

        const res = await updateDoctorStatus(selectedDoctor?._id, item.status) as any; 

        if (res.data.status === 200) { 
  
          handleDoctor();

          dispatch(setNotificationMessage('Doctor Status Successfully Updated.')); 

          dispatch(setIsRefreshDoctorsList(true)); 
  
        }; 

      }; 

    }; 

    return (

      <Box sx={{ 
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center', 
        width: '50%',
        height: '95%', 
    }}>

      <Box
          sx={{ 
              display: 'flex',
              flex: 'row',
              alignItems: 'center',
              width: '100%', 
              color: colors?.text, 
              marginBottom: 2,
              paddingLeft: 3, 
              fontWeight: 'bold'
          }}
      >Account Information
     </Box>  

      {((selectedGroupAccess?.doctorId == selectedDoctor?._id) && (selectedGroupAccess?.groupId == selectedGroup?._id)) && 
        <InfoRow 
          title={`${selectedGroup?.name} (Group Access)`}
          icon={<ApartmentIcon sx={{ color: colors?.mainHover }} />}
          description={ 
          <strong 
            style={{ 
              padding: 5,
              borderRadius: 7,
              backgroundColor: getStatusColor(selectedGroupAccess?.status), 
              color: 'white', 
            }}>
          {getCapitalizedString(selectedGroupAccess?.status)}
          </strong>}
          listHandler={handleGroupStatus}
          listIcon={<SettingsIcon sx={{ color: colors?.main }} />}
          dataList={groupAccessStatusList}
          rowIcon={<TollIcon sx={{ color: 'blue' }} />}
          rowTitle={'title'}
          rowDescription={'status'}
        />}

      <InfoRow 
        title='Full Name'
        icon={<AccountBoxIcon sx={{ color: colors?.main }} />}
        description={`${selectedDoctor?.firstName} ${selectedDoctor?.lastName}`}
      />

      <InfoRow 
        title='Identifier'
        icon={<FingerprintIcon sx={{ color: colors?.main }} />}
        description={selectedDoctor?._id}
        descriptionStyle={{ fontSize: 12, color: colors?.mainHover }}
      />

      <InfoRow 
        title='Status'
        icon={<SignalWifiStatusbar4BarIcon sx={{ color: colors?.main }} />}
        description={ 
        <strong 
          style={{ 
            padding: 5,
            borderRadius: 7,
            backgroundColor: getStatusColor(selectedDoctor?.accountStatus), 
            color: 'white', 
          }}>
        {getCapitalizedString(selectedDoctor?.accountStatus)}
        </strong>}
        listHandler={handleDoctorStatus}
        listIcon={<SettingsIcon sx={{ color: colors?.main }} />}
        dataList={groupAccessStatusList}
        rowIcon={<TollIcon sx={{ color: 'blue' }} />}
        rowTitle={'title'}
        rowDescription={'status'}
      />

      <InfoRow 
        title='Email'
        icon={<EmailIcon sx={{ color: colors?.main }} />}
        description={selectedDoctor?.email}
      />

      <InfoRow 
        title='Last Active'
        icon={<UpdateIcon sx={{ color: colors?.main }} />}
        description={moment(selectedDoctor?.lastActive).utc(true).format('LLLL')}
        descriptionStyle={{ fontSize: 12,  color: 'rgb(150, 150, 150)'}}
      />

      <InfoRow 
        title='Created On'
        icon={<CalendarMonthIcon sx={{ color: colors?.main }} />}
        description={moment(selectedDoctor?.createdAt).utc(true).format('LLLL')}
        descriptionStyle={{ fontSize: 12,  color: 'rgb(150, 150, 150)'}}
      />

    </Box>

  );

};

export default DoctorSettings;